<div class="responsive-container p-grid">
  <p-panel>
    <ng-template pTemplate="header">
      <div class="responsive-header">
        <div>
          <span class="responsive-header-title">
            Escaneo de Nuevos Artículos
            <p class="responsive-header-subtitle">{{ accountName }}</p>
          </span>
        </div>

        <div class="flex gap-2 align-items-center">
          <button pButton icon="pi pi-times" class="p-button-rounded p-button-text"
          (click)="onClose()"></button>
        </div>
      </div>
    </ng-template>

  <p-fluid>
    <div class="content">
      <!-- View Messages -->
      <p-toast [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }" />

      <!-- Campo de descripción -->
      <div class="field">
        <label for="description">Descripción <span class="req">*</span></label>
        <input id="description" [(ngModel)]="description" id="description" type="text" pInputText
          placeholder="Descripción del Artículo" />
      </div>

      <!-- Campo de SKU-->
      <div class="field">
        <label for="serialNumber">SKU</label>
        <input id="serialNumber" [(ngModel)]="serialNumber" id="serialNumber" type="text" pInputText
          placeholder="Número de Serie" />
      </div>

      <!-- Campo de cantidad -->
      <div class="field">
        <label for="quantity">Cantidad de artículos <span class="req">*</span></label>
        <p-inputNumber [(ngModel)]="quantity" placeholder="Cantidad" [min]="1" [max]="100000"
        inputId="integeronly" [showButtons]="true"></p-inputNumber>
      </div>

      <!-- Manual Scanner -->
      <div class="field">
        <label for="manualQr">Código QR</label>
        <input id="manualCode" type="text" pInputText placeholder="Escanea el Código QR"
          [(ngModel)]="manualQrCode" (input)="onManualInputChange()" />
      </div>

      <!-- Lista de artículos escaneados -->
      <div class="field">
        <p-table [value]="scannedItems" styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th>QR</th>
              <th>Descripción</th>
              <th>#</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-i="rowIndex" let-editing="editing">
            <tr>
              <td>{{ item.code }}</td>
              <td [pEditableColumn]="item.description" pEditableColumnField="Descripción">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText type="text" [(ngModel)]="item.description" />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ item.description }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td [pEditableColumn]="item.quantity" pEditableColumnField="Cantidad">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-inputNumber [(ngModel)]="item.quantity" [min]="1" [max]="100000" />
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ item.quantity }}
                  </ng-template>
                </p-cellEditor>
              </td>
              <td>
                <p-button icon="pi pi-trash" severity="danger" [outlined]="true"
                (click)="removeItem(i)"></p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <!-- Botones de acción -->
      <div class="p-col-12 flex justify-content-between">
        <p-button label="Paletizar" icon="pi pi-box" severity="secondary" (click)="onPaletize()"
        [disabled]="!scannedItems.length"></p-button>
        <p-button label="Guardar" icon="pi pi-save" (click)="onSave()"
        [disabled]="!scannedItems.length"></p-button>
      </div>
    </div>
  </p-fluid>
  </p-panel>
</div>
<p-confirmDialog></p-confirmDialog>